/**
 * Desk mutation toast copy — plan/38 + plan/27.
 * Create → Added/Saved; applied PATCH → Updated; gated queue → Request sent.
 */

export function toastAdded(subject: string): string {
  const s = subject.trim();
  return s ? `Added ${s}` : "Added";
}

export function toastSaved(subject: string): string {
  const s = subject.trim();
  return s ? `Saved ${s}` : "Saved";
}

export function toastUpdated(subject: string): string {
  const s = subject.trim();
  return s ? `Updated ${s}` : "Updated";
}

export function toastRequestSent(subject?: string): string {
  const s = (subject ?? "").trim();
  return s ? `Request sent — ${s}` : "Request sent";
}
